import React from 'react'
import SarasTrans from '../../../library/notifications/SarasTrans';

//starting with capital letter will ensure this is treated as a component
const InvGridItemMatOutH = ({col}) => {

    return (
        <div className="uiSearchSubList">
            <span className="sItemCode uiCenter"><SarasTrans value="Cat"/></span>
            <span className="sItemID uiCenter"><SarasTrans value="Item"/></span>
            <span className="sItemWeight uiCenter"><SarasTrans value="Qty Out"/></span>
            <span className="sItemWeight uiCenter"><SarasTrans value="Qty Ret"/></span>
        </div>
    );
}

export default InvGridItemMatOutH
